import { render, staticRenderFns } from "./CardPanel.vue?vue&type=template&id=3b1bdeb6"
import script from "./CardPanel.vue?vue&type=script&lang=ts"
export * from "./CardPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports